var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionNews"}},[_c('Wrap',[_vm._l((_vm.posts),function(post){return _c('CardPost',{key:post.id,attrs:{"post":post}})}),(_vm.postsCount > _vm.limitNews)?_c('PaginationShowMore',{attrs:{"limit":_vm.limitNews,"name":"news","total":_vm.postsCount},on:{"update:limit":function($event){_vm.limitNews=$event}}}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }